import { useEffect, useRef } from 'react'
import Option from './option'
import styles from './options.module.css'

const Options = props => {
  const options = useRef()

  // Przy otwarciu przewijamy do wybranej pozycji, a po wpisaniu tekstu – na początek wyników.
  useEffect(() => {
    options.current.scrollTo({top: props.query ? 0 : props.value * 50})
  }, [props.active, props.query])

  return (
    <div
      className={styles.options}
      ref={options}
      aria-hidden={!props.active}
      inert={!props.active}
      data-scrollable
    >
      {Object.entries(props.options).map(([id, option]) => (
        <Option
          key={id}
          active={props.active}
          onClick={() => props.onChange(id)}
        >
          {option}
        </Option>
      ))}
      {!Object.keys(props.options).length && (
        <div className={styles.empty}>Brak wyników</div>
      )}
    </div>
  )
}

export default Options
